import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { AddNewClientComponent } from '../../addnewclient/addnewclient.component';
import { AddDocumentComponent } from '../../adddocument/adddocument.component';
import { AddDepartmentComponent } from '../../add-department/add-department.component';
import {MatRadioModule} from '@angular/material/radio';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminDashboardComponent } from 'app/admindashboard/admindashboard.component';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatRadioModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    NgSelectModule
  ],
  declarations: [
    AddNewClientComponent,
    AddDocumentComponent,
    AddDepartmentComponent,
    AdminDashboardComponent
    ]
})

export class AdminLayoutModule {}
